module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_oslo_viken_neg.002f88c6.png";